//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ArtOxygenDifference',
  data () {
    return {
      form: {
        CaO2: '',
        CvO2: ''
      },
      hasScore: false,
      disabled: false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        console.log(form)
        let result = form.CaO2 - form.CvO2
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/ArtOxygenDifference.vue